import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

function transformLangKeys(obj) {
  const result = {}

  for (const [key, value] of Object.entries(obj)) {
    let newKey

    if (key === 'zh-hans') {
      newKey = 'zh-Hans'
    } else if (key === 'zh-hant') {
      newKey = 'zh-Hant'
    } else {
      // 普通情况：全大写
      newKey = key.toUpperCase()
    }

    result[newKey] = value
  }

  return result
}

const webshop_lang = transformLangKeys(window.webshop_lang || {})
export default new VueI18n({
  locale: 'EN',
  fallbackLocale: 'EN',
  messages: webshop_lang,
})
